import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';

import Dashboard from './Dashboard/index';
import Transactions from './Transactions/index';
import Settlement from './Settlement/index'

const apall = (props) => {
    var match = props.match;
    return (
        <div className="app-wrapper">
            <Switch>
                <Redirect exact from={`${match.url}/`} to={`${match.url}/dashboard`}/>
                <Route path={`${match.url}/dashboard`} render={() => (<Dashboard {...props}/>)}/>
                <Route path={`${match.url}/transactions`} render={() => (<Transactions {...props}/>)}/>
                <Route path={`${match.url}/settlement`} render={() => (<Settlement {...props}/>)}/>
            </Switch>
        </div>
    );

}
export default apall;



// WEBPACK FOOTER //
// ./app/routes/apall/index.js